import { Redirect, Switch } from 'react-router-dom'
import DistributorOverview from './pages/DistributorOverview'
import AddDistributor from './pages/AddDistributor'
import EditDistributor from './pages/EditDistributor'
import HaynesProLicensesOverview from './HaynesPro/HaynesProLicensesOverview'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_LICENSES } from 'app-support/permissions/Permissions'
import { distributorRoute, distributorRouteEdit, distributorRouteNew, haynesproLicenseRoute, licensesRoute } from 'routes/routeNames'

const LicensesRoutes = () => (
  <Switch>
    <Redirect path={licensesRoute} exact to={distributorRoute} />

    <PermissionRoute permission={PERMISSION_MANAGE_LICENSES} exact path={distributorRoute} component={DistributorOverview} />
    <PermissionRoute permission={PERMISSION_MANAGE_LICENSES} exact path={haynesproLicenseRoute} component={HaynesProLicensesOverview} />
    <PermissionRoute permission={PERMISSION_MANAGE_LICENSES} exact path={distributorRouteNew} component={AddDistributor} />
    <PermissionRoute permission={PERMISSION_MANAGE_LICENSES} exact path={distributorRouteEdit} component={EditDistributor} />
  </Switch>
)

export default LicensesRoutes
